import Velocity from 'velocity-animate'
import { Element } from 'src/utils/helper/element'
import { TimeoutUtil, IntervalUtil } from 'src/utils/helper/timer'

export default {
  name: 'fou-slider',

  data() {
    return {
      slides: [],
      scrollEnd: false,
      pos: 0,
      shiftKey: false,
      keyTimer: TimeoutUtil(),
      widthTimer: IntervalUtil(),
      status: 'unset',
      contentW: 0,
      slidesW: 0
    }
  },

  props: {
    slave: {
      /**
       * set to true if you want that slider gets control through another slider.
       */
      type: Boolean,
      default: false
    },
    slaves: {
      /**
       * Add $vId() of the slave slider to this prop to control remotely.
       */
      type: Array,
      default: function () {
        return []
      }
    }
  },

  mounted() {
    this.setEvents()
    this.setWatcher()
    this.status = 'set'
  },

  updated() {
    this.setWidths()
  },

  beforeUnmount() {
    this.widthTimer.clear()
  },

  methods: {
    isSet() {
      return this.status === 'set'
    },
    setWatcher() {
      /**
       * Pretty bad, but for now …
       */
      this.widthTimer.set(() => {
        this.setWidths()
      }, 50)
    },
    setEvents() {
      this.$events?.$on('window:shift:down', () => {
        this.shiftKey = true
        this.keyTimer.clear()
        this.keyTimer.set(() => {
          this.shiftKey = false
        }, 500)
      })
      this.$events?.$on('window:tab:down', event => {
        const direction = this.shiftKey === true ? 'prev' : 'next'
        event.path.some(p => {
          if (p.id && this.$vId(this) === p.id) {
            this.slideMove(direction)
          }
        })
      })
      this.$events?.$on('fou-slider:slide', event => {
        if (this.slave === true) {
          event.slaves.some(id => {
            if (id === this.id) {
              this.pos = event.pos
              this.slide(event.off, event.options)
              return true
            }
          })
        }
      })
    },
    canPrev() {
      return this.pos > 0 && !this.slave && this.hasOverflow()
    },
    canNext() {
      return !this.scrollEnd && !this.slave && this.hasOverflow()
    },
    getSlides() {
      /**
       * @Return {Array}
       */
      if (this.$refs.content) {
        const list = this.$refs.content.querySelector('ul')
        return list !== null ? Array.from(list.querySelectorAll('li')) : []
      } else {
        return []
      }
    },
    setWidths() {
      if (this.isSet()) {
        this.contentW = Element(this.$refs.content).outerWidth(true)
        this.slidesW = this.getSlidesWidth(this.getSlides())
      }
    },
    getSlidesWidth(slides = []) {
      let width = 0
      slides.map(slide => {
        width += Element(slide).outerWidth(true)
      })
      return width
    },
    hasOverflow() {
      this.setWidths()
      const overflow = this.contentW !== 0 && this.contentW - this.slidesW < 0
      return overflow
    },
    slideMove(direction) {
      this.setPos(direction).then(() => {
        this.slide(this.getOff(), {
          duration: 200,
          easing: 'ease-in'
        })
      })
    },
    getOff() {
      const slides = this.getSlides().slice(0, this.pos)
      return -1 * this.calcOff(slides)
    },
    calcOff(slides) {
      this.setWidths()
      const slidedW = this.getSlidesWidth(slides)
      const overflowW = this.slidesW - this.contentW
      this.scrollEnd = slidedW > overflowW
      return this.scrollEnd ? overflowW : slidedW
    },
    setPos(direction) {
      return new Promise(resolve => {
        const slideLen = this.getSlides().length
        if (direction === 'prev') {
          if (this.pos - 1 >= 0) {
            this.pos--
          }
        }
        if (direction === 'next') {
          if (this.pos + 1 < slideLen) {
            this.pos++
          }
        }
        resolve()
      })
    },
    slide(off, options) {
      Velocity(
        this.$refs.content,
        {
          left: off
        },
        options
      )
      if (this.slaves.length > 0 && !this.slave) {
        this.$events?.$emit('fou-slider:slide', {
          slaves: this.slaves,
          pos: this.pos,
          off,
          options
        })
      }
    }
  }
}
